export default __webpack_public_path__ + "static/media/cli-alph-resi_flores.b4153ed4.jpg";